// Import necessary dependencies and utilities
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";


const planningReportAPI = createApi({
    reducerPath: "planningReportAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({ 
        getPlanningReportById: builder.query({
            query: ({ teamId, planningId }) => ({
                url: `TeamResourcePlanning/GetPlanningReportById?TeamId=${teamId}&PlanningId=${planningId}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
       
    })
})

export const {
useLazyGetPlanningReportByIdQuery,
} = planningReportAPI;

export default planningReportAPI;